var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paypal-button-container-outer" }, [
    !_vm.isRendered
      ? _c("i", { staticClass: "fa-solid fa-spinner fa-spin fa-2x" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { ref: "paypal-button-container" }),
    _vm._v(" "),
    _c("div", { attrs: { role: "alert" } }, [
      _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }